import { ResourceNotFoundNotification } from "%notifications";
import { pushNotification } from "%error/utils";
import router from "%root/router";

const RESOURCES = {
  MESSAGE_NOT_FOUND: { name: "ogłoszenie", mode: "N" }
};

const LOCATIONS = {
  MESSAGE_NOT_FOUND: "/messages",
  VIDEO_NOT_FOUND: "/videos"
};

export default {
  supports(status) {
    return status === 404;
  },

  handle({ code }) {
    pushNotification(ResourceNotFoundNotification, {
      resource: RESOURCES[code]
    });

    router.push(LOCATIONS[code]);
  }
};
